import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const dashboardImages = [
  {
    src: 'https://www.verge.io/wp-content/uploads/2026/02/Light_GUI_for_Home_Page-scaled.webp',
    alt: 'VergeOS kontrol paneli — işlem kümeleri, ağ ve kiracı yönetimi',
  },
  {
    src: 'https://www.verge.io/wp-content/uploads/2026/02/Node_GUI_for_Website-scaled.webp',
    alt: 'VergeOS node paneli — sunucu donanımı, performans metrikleri ve GPU durumu',
  },
  {
    src: 'https://www.verge.io/wp-content/uploads/2026/02/Sites_New_GUI-scaled.webp',
    alt: 'VergeOS site paneli — çoklu site yönetimi ve replikasyon',
  },
];

const awards = [
  {
    src: 'https://www.verge.io/wp-content/uploads/2026/02/DCIG-Top5-VMware-Alternatives-SME-Edition-600x600-padded-removebg.png',
    alt: 'DCIG Top 5 VMware Alternatifleri 2026',
  },
  {
    src: 'https://www.verge.io/wp-content/uploads/2026/02/MES_Midmarket_100_2025_Logo_600x600_padded.png',
    alt: 'MES Midmarket 100 2025',
  },
  {
    src: 'https://www.verge.io/wp-content/uploads/2026/02/2025_CRN_Storage100_vertical_600x600_padded-removebg.png',
    alt: 'CRN Storage 100 2025',
  },
  {
    src: 'https://www.verge.io/wp-content/uploads/2026/02/DCIG-2024-25-TOP-5-SMB-Edge-VMware-vSphere-Alternatives-Icon-600.png',
    alt: 'DCIG Top 5 VMware vSphere Alternatifleri 2024-25',
  },
];

export default function HeroSection() {
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveImg((prev) => (prev + 1) % dashboardImages.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-white border-b border-gray-100 py-16 px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-12">
          {/* Sol sütun */}
          <div className="flex-1 min-w-0">
            {/* Rozet */}
            <div className="inline-flex items-center gap-2 bg-orange-50 border border-orange-200 text-[#e8600a] text-xs font-semibold px-3 py-1.5 rounded-full mb-6">
              <i className="ri-star-fill text-[#e8600a]"></i>
              En iyi Sanallaştırma Alternatifi
            </div>

            <h1 className="text-4xl xl:text-5xl font-bold text-[#1a1a2e] leading-tight mb-2">
              Özel Bulut İşletim Sistemi
            </h1>
            <h2 className="text-3xl xl:text-4xl font-bold text-[#e8600a] leading-tight mb-6">
              altyapınızı modernize eder
            </h2>

            <p className="text-base font-semibold text-[#1e293b] mb-3">Beş ürün tek bir çözümde:</p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-1.5 mb-6">
              {['Sanallaştırma', 'Veri Koruma', 'Depolama', 'Otomasyon', 'Ağ Yönetimi'].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-[#374151]">
                  <i className="ri-checkbox-circle-fill text-[#e8600a] text-base"></i>
                  {item}
                </li>
              ))}
            </ul>

            <p className="text-sm text-[#64748b] leading-relaxed mb-8 max-w-lg">
              VergeOS bu beş ürünü, mevcut sunucularınızda çalışan tek bir işletim sisteminde birleştirir —
              böylece diğer sanallaştırma platformunuzdan dakikalar içinde geçiş yapabilir, altyapı maliyetlerinizi yarıya indirebilir
              ve veri merkezinizi geleceğe hazırlayabilirsiniz.
            </p>

            {/* İstatistikler */}
            <div className="flex gap-8 mb-8">
              <div>
                <div className="text-3xl font-bold text-[#e8600a]">%70</div>
                <div className="text-xs text-[#64748b] mt-0.5">Capex/Opex Tasarrufu</div>
              </div>
              <div className="w-px bg-gray-200"></div>
              <div>
                <div className="text-3xl font-bold text-[#1a1a2e]">1</div>
                <div className="text-xs text-[#64748b] mt-0.5">Kod Tabanı, GUI, API</div>
              </div>
              <div className="w-px bg-gray-200"></div>
              <div>
                <div className="text-3xl font-bold text-[#1a1a2e]">1</div>
                <div className="text-xs text-[#64748b] mt-0.5">Host Başına Lisans</div>
              </div>
            </div>

            {/* CTA */}
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 bg-[#e8600a] text-white font-semibold px-6 py-3 rounded-md hover:bg-[#cc5208] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-check-line"></i>
              Teknik Sunum Planla
            </Link>
          </div>

          {/* Sağ sütun */}
          <div className="flex-1 min-w-0">
            {/* Dashboard görselleri */}
            <div className="relative w-full" style={{ aspectRatio: '1446/984' }}>
              {dashboardImages.map((img, idx) => (
                <img
                  key={img.src}
                  src={img.src}
                  alt={img.alt}
                  className={`absolute inset-0 w-full h-full object-cover rounded-lg border border-gray-200 transition-opacity duration-700 ${
                    idx === activeImg ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              ))}
              {/* Noktalar */}
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
                {dashboardImages.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveImg(idx)}
                    className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${
                      idx === activeImg ? 'bg-[#e8600a]' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* Sektör Onayları */}
            <div className="mt-6">
              <p className="text-xs font-semibold text-[#64748b] uppercase tracking-wider mb-3 text-center">Sektör Tarafından Onaylandı</p>
              <div className="flex items-center justify-center gap-4">
                {awards.map((award) => (
                  <div key={award.src} className="w-14 h-14 flex items-center justify-center">
                    <img src={award.src} alt={award.alt} className="w-full h-full object-contain" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
